<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-body tab2-card">
          <fieldset *ngIf="editable" enabled style="border:none">
            <form [formGroup]="form" class="needs-validation" novalidate>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Operator de retea</label>
                  <input class="form-control" type="text" formControlName="operatorName" disabled>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>POD<span>*</span></label>
                  <input class="form-control" type="text" formControlName="code">
                </div>
              </div>
              <br>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <h4> Adresa locului de consum </h4>
                </div>
              </div>
              <br>
              <div class="form-group row">
                <div class="col-xl-4 col-sm-4 mb-0">
                  <label>Judet<span>*</span></label>
                  <select class="form-control digits" formControlName="county" (change)="onChangeCounty()">
                    <option *ngFor="let county of counties" [value]="county.id">
                      {{ county.name }} </option>
                  </select>
                </div>
                <div class="col-xl-4 col-sm-4 mb-0">
                  <label>Localitate<span>*</span></label>
                  <select class="form-control digits" formControlName="city">
                    <option *ngFor="let city of cities" [value]="city.id">
                      {{ city.name }} </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Strada<span>*</span></label>
                  <input class="form-control" type="text" formControlName="streetName" required />
                  <div *ngIf="form.controls['streetName'].errors && (form.dirty || form.touched) && isFormSubmitAttempt"
                    class="text text-danger">
                    Numele strazii este obligatoriu
                  </div>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Numar<span>*</span></label>
                  <input class="form-control" type="text" formControlName="streetNumber" required />
                  <div
                    *ngIf="form.controls['streetNumber'].errors && (form.dirty || form.touched) && isFormSubmitAttempt"
                    class="text text-danger">
                    Numarul strazii este obligatoriu
                  </div>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Bloc</label>
                  <input class="form-control" type="text" formControlName="block" />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Etaj</label>
                  <input class="form-control" type="text" formControlName="floor" />
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Apartament</label>
                  <input class="form-control" type="text" formControlName="apartment" />
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Cod postal<span>*</span></label>
                  <input class="form-control" type="text" formControlName="postalCode" required />
                  <div *ngIf="form.controls['postalCode'].errors && (form.dirty || form.touched) && isFormSubmitAttempt"
                    class="text text-danger">
                    Codul postal este obligatoriu
                  </div>
                </div>
              </div>
              <br>
              <ng-container *ngIf="!editable">
                <div class="form-group row" *ngIf="false">
                  <div class="col-xl-4 col-md-4">
                    <label>Modul de contractare al serviciului de retea</label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="networkContractType">
                      Prin furnizor
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="networkContractType">
                      Direct
                    </label>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-xl-4 col-md-4">
                    <label>Tip contract</label>
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="contractType">
                      Distributie
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="contractType">
                      Transport
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Numar contract</label>
                    <input class="form-control" type="text" formControlName="contractNumber">
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Data contract</label>
                    <input class="form-control" type="date" formControlName="validFrom" onkeydown="return false">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-xl-4 col-md-4">
                    <label>Exista conventie?</label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="isConvention" [checked]="isConventionPresent()">
                      DA
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" [checked]="!isConventionPresent()" name="isConvention">
                      NU
                    </label>
                  </div>
                  <ng-container *ngIf="isConventionPresent()">
                    <div class="form-group row">
                      <div class="col-xl-4 col-md-4">
                        <label>Tip conventie</label>
                        <label class="d-block">
                          <input class="radio_animated" type="radio" name="convention">
                          Tripartita
                        </label>
                        <label class="d-block">
                          <input class="radio_animated" type="radio" name="convention">
                          Multipartita
                        </label>
                      </div>
                      <div class="col-xl-4 col-md-4">
                        <label>Numar conventie</label>
                        <input class="form-control" type="text" formControlName="conventionNumber">
                      </div>
                      <div class="col-xl-4 col-md-4">
                        <label>Data conventie</label>
                        <input class="form-control" type="date" formControlName="conventionDate"
                          onkeydown="return false">
                      </div>
                    </div>
                  </ng-container>
                </div>
                <ng-container *ngIf="isConventionPresent()">
                  <div class="form-group row">
                    <div class="col-xl-2 col-md-2">
                      <label>Parti conventie</label>
                    </div>
                    <div style="height: 100px" class="col-xl-2 col-md-2 overflow-auto border">
                      <div *ngFor="let part of conventionParts" class="row">
                        <span class="list-item">{{part}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-xl-2 col-md-2">
                      <label class="d-block">
                        <input class="checkbox_animated" type="checkbox">
                        Exista mai multi furnizori
                      </label>
                    </div>
                    <div style="height: 100px" class="col-xl-2 col-md-2 overflow-auto border">
                      <div *ngFor="let supplier of suppliers" class="row">
                        <span class="list-item">{{supplier}}</span>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Are calitate de prosumator?<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setProsumer(true)" [checked]="isProsumer()">
                    DA
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setProsumer(false)" [checked]="isNotProsumer()">
                    NU
                  </label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label class="d-block">
                    <input class="checkbox_animated" type="checkbox" formControlName="connectionCertificate">
                    Certificat racordare<span>*</span>
                  </label>
                </div>
                <ng-container *ngIf="!!form?.controls?.connectionCertificate?.value">
                  <div class="col-xl-4 col-md-4">
                    <label>Numar<span>*</span></label>
                    <input class="form-control" type="text" formControlName="connectionCertificateNumber">
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Data<span>*</span></label>
                    <input class="form-control" type="date" formControlName="connectionCertificateDate"
                      onkeydown="return false">
                  </div>
                </ng-container>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label class="d-block">
                    <input class="checkbox_animated" type="checkbox" formControlName="connectionNotice">
                    Aviz tehnic de racordare<span>*</span>
                  </label>
                </div>
                <ng-container *ngIf="!!form?.controls?.connectionNotice?.value">
                  <div class="col-xl-4 col-md-4">
                    <label>Numar<span>*</span></label>
                    <input class="form-control" type="text" formControlName="connectionNoticeNumber">
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Data<span>*</span></label>
                    <input class="form-control" type="date" formControlName="connectionNoticeDate"
                      onkeydown="return false">
                  </div>
                </ng-container>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Exista un sistem de masurare inteligent<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" [checked]="isSmartMeter()" (click)="setSmartMeter(true)">
                    DA
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" [checked]="isNotSmartMeter()"
                      (click)="setSmartMeter(false)">
                    NU
                  </label>
                </div>
                <ng-container>
                  <div class="col-xl-4 col-md-4">
                    <label>Tip contor<span>*</span></label>
                    <select class="form-control digits" formControlName="counterType">
                      <option value="ACTIVE">ACTIV</option>
                      <option value="REACTIVE">REACTIV</option>
                      <option value="ACTIVE_REACTIVE">ACTIV_REACTIV</option>
                    </select>
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Serie contor<span>*</span></label>
                    <input class="form-control" type="text" formControlName="counterSeries">
                  </div>
                </ng-container>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Status loc de consum<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setTechnicalDataStatus('CONECTAT')"
                      [checked]="isConsumptionPlaceConnected()">
                    Conectat
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setTechnicalDataStatus('DECONECTAT')"
                      [checked]="isConsumptionPlaceDisconnected()">
                    Deconectat
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setTechnicalDataStatus('INACTIV')"
                      [checked]="isConsumptionPlaceInactive()">
                    Inactiv
                  </label>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Tip retea<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setNetworkType('D')"
                      [checked]="isNetworkTypeDistribution()">
                    Distributie
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setNetworkType('T')"
                      [checked]="isNetworkTypeTransport()">
                    Transport
                  </label>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Regim de functionare<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setOperatingMode('PERMANENT')"
                      [checked]=isOperatingModePermanent()>
                    Permanent
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setOperatingMode('SEZONIER')"
                      [checked]=isOperatingModeSeasonal()>
                    Sezonier
                  </label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Tip racord<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setConnectionType('MONOFAZAT')"
                      [checked]="isConnectionTypeMono()">
                    Monofazat
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setConnectionType('TRIFAZAT')"
                      [checked]="isConnectionTypeTri()">
                    Trifazat
                  </label>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Puterea aprobata(W)<span>*</span></label>
                  <input class="form-control" type="number" formControlName="approvedConsumptionPower">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Nivel de tensiune(V)<span>*</span></label>
                  <input class="form-control" type="number" formControlName="voltageLevel">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Perioada citire index(luni)<span>*</span></label>
                  <input class="form-control" type="number" formControlName="counterIndexInterval">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Descriere modalitate de completare index de la OR<span>*</span></label>
                  <textarea class="form-control"
                    placeholder="Trebuie sa completati valoare index multi-cadran: ex. 1.8.1:546|1.8.2:532|"
                    formControlName="counterIndexDesc"></textarea>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Valoarea ultimului index citit</label>
                  <input class="form-control" formControlName="counterIndexValue">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Data ultimului index citit</label>
                  <input class="form-control" type="date" formControlName="counterIndexReadDate"
                    onkeydown="return false">
                </div>
              </div>
            </form>
          </fieldset>
          <fieldset *ngIf="!editable" disabled style="border:none">
            <form [formGroup]="form" class="needs-validation" novalidate>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Operator de retea</label>
                  <input class="form-control" type="text" formControlName="operatorName" disabled>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>POD<span>*</span></label>
                  <input class="form-control" type="text" formControlName="code">
                </div>
              </div>
              <br>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <h4> Adresa locului de consum </h4>
                </div>
              </div>
              <br>
              <div class="form-group row">
                <div class="col-xl-4 col-sm-4 mb-0">
                  <label>Judet<span>*</span></label>
                  <select class="form-control digits" formControlName="county" (change)="onChangeCounty()">
                    <option *ngFor="let county of counties" [value]="county.id">
                      {{ county.name }} </option>
                  </select>
                </div>
                <div class="col-xl-4 col-sm-4 mb-0">
                  <label>Localitate<span>*</span></label>
                  <select class="form-control digits" formControlName="city">
                    <option *ngFor="let city of cities" [value]="city.id">
                      {{ city.name }} </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Strada<span>*</span></label>
                  <input class="form-control" type="text" formControlName="streetName" required />
                  <div *ngIf="form.controls['streetName'].errors && (form.dirty || form.touched) && isFormSubmitAttempt"
                    class="text text-danger">
                    Numele strazii este obligatoriu
                  </div>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Numar<span>*</span></label>
                  <input class="form-control" type="text" formControlName="streetNumber" required />
                  <div
                    *ngIf="form.controls['streetNumber'].errors && (form.dirty || form.touched) && isFormSubmitAttempt"
                    class="text text-danger">
                    Numarul strazii este obligatoriu
                  </div>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Bloc</label>
                  <input class="form-control" type="text" formControlName="block" />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Etaj</label>
                  <input class="form-control" type="text" formControlName="floor" />
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Apartament</label>
                  <input class="form-control" type="text" formControlName="apartment" />
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Cod postal<span>*</span></label>
                  <input class="form-control" type="text" formControlName="postalCode" required />
                  <div *ngIf="form.controls['postalCode'].errors && (form.dirty || form.touched) && isFormSubmitAttempt"
                    class="text text-danger">
                    Codul postal este obligatoriu
                  </div>
                </div>
              </div>
              <br>
              <ng-container *ngIf="!editable">
                <div class="form-group row" *ngIf="false">
                  <div class="col-xl-4 col-md-4">
                    <label>Modul de contractare al serviciului de retea</label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="networkContractType">
                      Prin furnizor
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="networkContractType">
                      Direct
                    </label>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-xl-4 col-md-4">
                    <label>Tip contract</label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="contractType"
                        [checked]="isNetworkTypeDistribution()">
                      Distributie
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="contractType"
                        [checked]="isNetworkTypeTransport()">
                      Transport
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Numar contract</label>
                    <input class="form-control" type="text" formControlName="contractNumber">
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Data contract</label>
                    <input class="form-control" type="date" formControlName="validFrom" onkeydown="return false">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-xl-4 col-md-4">
                    <label>Exista conventie?</label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="isConvention" [checked]="isConventionPresent()">
                      DA
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" [checked]="!isConventionPresent()" name="isConvention">
                      NU
                    </label>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-xl-4 col-md-4">
                    <label>Tip conventie</label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="convention">
                      Tripartita
                    </label>
                    <label class="d-block">
                      <input class="radio_animated" type="radio" name="convention">
                      Multipartita
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Numar conventie</label>
                    <input class="form-control" type="text" formControlName="conventionNumber">
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Data conventie</label>
                    <input class="form-control" type="date" formControlName="conventionDate" onkeydown="return false">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-xl-2 col-md-2">
                    <label>Parti conventie</label>
                  </div>
                  <div style="height: 100px" class="col-xl-2 col-md-2 overflow-auto border">
                    <div *ngFor="let part of conventionParts" class="row">
                      <span class="list-item">{{part}}</span>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-xl-2 col-md-2">
                    <label class="d-block">
                      <input class="checkbox_animated" type="checkbox">
                      Exista mai multi furnizori
                    </label>
                  </div>
                  <div style="height: 100px" class="col-xl-2 col-md-2 overflow-auto border">
                    <div *ngFor="let supplier of suppliers" class="row">
                      <span class="list-item">{{supplier}}</span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Are calitate de prosumator?<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setProsumer(true)" [checked]="isProsumer()">
                    DA
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setProsumer(false)" [checked]="isNotProsumer()">
                    NU
                  </label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label class="d-block">
                    <input class="checkbox_animated" type="checkbox" formControlName="connectionCertificate">
                    Certificat racordare<span>*</span>
                  </label>
                </div>
                <ng-container *ngIf="!!form?.controls?.connectionCertificate?.value">
                  <div class="col-xl-4 col-md-4">
                    <label>Numar<span>*</span></label>
                    <input class="form-control" type="text" formControlName="connectionCertificateNumber">
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Data<span>*</span></label>
                    <input class="form-control" type="date" formControlName="connectionCertificateDate"
                      onkeydown="return false">
                  </div>
                </ng-container>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label class="d-block">
                    <input class="checkbox_animated" type="checkbox" formControlName="connectionNotice">
                    Aviz tehnic de racordare<span>*</span>
                  </label>
                </div>
                <ng-container *ngIf="!!form?.controls?.connectionNotice?.value">
                  <div class="col-xl-4 col-md-4">
                    <label>Numar<span>*</span></label>
                    <input class="form-control" type="text" formControlName="connectionNoticeNumber">
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Data<span>*</span></label>
                    <input class="form-control" type="date" formControlName="connectionNoticeDate"
                      onkeydown="return false">
                  </div>
                </ng-container>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Exista un sistem de masurare inteligent<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" [checked]="isSmartMeter()" (click)="setSmartMeter(true)">
                    DA
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" [checked]="isNotSmartMeter()"
                      (click)="setSmartMeter(false)">
                    NU
                  </label>
                </div>
                <ng-container>
                  <div class="col-xl-4 col-md-4">
                    <label>Tip contor<span>*</span></label>
                    <select class="form-control digits" formControlName="counterType">
                      <option value="ACTIVE">ACTIV</option>
                      <option value="REACTIVE">REACTIV</option>
                      <option value="ACTIVE_REACTIVE">ACTIV_REACTIV</option>
                    </select>
                  </div>
                  <div class="col-xl-4 col-md-4">
                    <label>Serie contor<span>*</span></label>
                    <input class="form-control" type="text" formControlName="counterSeries">
                  </div>
                </ng-container>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Status loc de consum<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setTechnicalDataStatus('CONECTAT')"
                      [checked]="isConsumptionPlaceConnected()">
                    Conectat
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setTechnicalDataStatus('DECONECTAT')"
                      [checked]="isConsumptionPlaceDisconnected()">
                    Deconectat
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setTechnicalDataStatus('INACTIV')"
                      [checked]="isConsumptionPlaceInactive()">
                    Inactiv
                  </label>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Tip retea<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setNetworkType('D')"
                      [checked]="isNetworkTypeDistribution()">
                    Distributie
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setNetworkType('T')"
                      [checked]="isNetworkTypeTransport()">
                    Transport
                  </label>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Regim de functionare<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setOperatingMode('PERMANENT')"
                      [checked]=isOperatingModePermanent()>
                    Permanent
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setOperatingMode('SEZONIER')"
                      [checked]=isOperatingModeSeasonal()>
                    Sezonier
                  </label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Tip racord<span>*</span></label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setConnectionType('MONOFAZAT')"
                      [checked]="isConnectionTypeMono()">
                    Monofazat
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" (click)="setConnectionType('TRIFAZAT')"
                      [checked]="isConnectionTypeTri()">
                    Trifazat
                  </label>
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Puterea aprobata(W)<span>*</span></label>
                  <input class="form-control" type="number" formControlName="approvedConsumptionPower">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Nivel de tensiune(V)<span>*</span></label>
                  <input class="form-control" type="number" formControlName="voltageLevel">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Perioada citire index(luni)<span>*</span></label>
                  <input class="form-control" type="number" formControlName="counterIndexInterval">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Descriere modalitate de completare index de la OR<span>*</span></label>
                  <textarea class="form-control"
                    placeholder="Trebuie sa completati valoare index multi-cadran: ex. 1.8.1:546|1.8.2:532|"
                    formControlName="counterIndexDesc"></textarea>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-4 col-md-4">
                  <label>Valoarea ultimului index citit</label>
                  <input class="form-control" type="number" formControlName="counterIndexValue">
                </div>
                <div class="col-xl-4 col-md-4">
                  <label>Data ultimului index citit</label>
                  <input class="form-control" type="date" formControlName="counterIndexReadDate"
                    onkeydown="return false">
                </div>
              </div>
            </form>
          </fieldset>
          <br>
          <div class="form-group row mb-0 pull-right">
            <div class="col-xl-auto col-md-auto">
              <button [routerLink]="'..'" type="button" class="btn btn-light button-margin">Renunta</button>
              <button *ngIf="editable" type="button" class="btn btn-primary mr-1 button-margin" (click)="onSubmit()">
                Salveaza
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>